/* eslint-disable @typescript-eslint/no-explicit-any */

import { tokenStorage } from 'utils';
import { parseApiError } from 'utils/parseApiError';
import { BACKEND_HOST, WS_HOST } from 'config';

export const backendHost = BACKEND_HOST;
// Хост (домен) для WebSocket/Pusher, без /api
export const wsHost = WS_HOST;

// Типы
type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface ApiError extends Error {
  status: number;
  data?: any;
}

// Флаг, чтобы не запустить редирект дважды при параллельных 401-ответах.
let unauthorizedHandled = false;

function handleUnauthorized(): void {
  if (unauthorizedHandled) return;
  unauthorizedHandled = true;

  tokenStorage.remove();
  // Чистим persist Zustand authStore, чтобы PrivateRoute не пустил обратно
  // на закрытые маршруты до перезагрузки.
  try {
    localStorage.removeItem('absolut-auth');
  } catch {
    /* ignore */
  }
  window.location.href = '/login?reason=session_expired';
}

export default async function apiReq<T = any>(
  path: string | null = null,
  method: HttpMethod = 'GET',
  body?: any,
  isFormData?: boolean
): Promise<T | undefined> {
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
  };

  if (isFormData) {
    delete headers['Content-Type'];
  }

  const token = tokenStorage.get();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${backendHost}/${path}`, {
    method,
    headers,
    redirect: 'manual',
    body: body ? (isFormData ? body : JSON.stringify(body)) : null,
  });

  // console.log('got res: ', res);
  if (res.type === 'opaqueredirect') {
    // console.log('got res: ', res.headers);
    // console.log('got Location: ', res.headers.get('Location'));
    window.location.href = res.url || '';
    return undefined;
  }

  const json = await res.json().catch(() => null);

  if (!res.ok) {
    if (res.status === 401) {
      // На эндпоинте логина 401 = неверные креды, не истёкшая сессия.
      // Пробрасываем ошибку дальше, чтобы LoginPage показал «Неверный email или пароль».
      const isLoginRequest = path === 'auth/login';
      const alreadyOnLoginPage =
        typeof window !== 'undefined' && window.location.pathname === '/login';

      if (!isLoginRequest && !alreadyOnLoginPage) {
        handleUnauthorized();
        // Возвращаем never-resolving промис, чтобы вызывающий код не выполнил
        // .then с пустыми данными до того, как сработает редирект.
        return new Promise<never>(() => undefined);
      }

      const { generalMessage } = parseApiError(json);
      const error = new Error(generalMessage || 'Не авторизован') as ApiError;
      error.status = 401;
      error.data = json;
      throw error;
    }
    const { generalMessage } = parseApiError(json);
    const error = new Error(generalMessage || res.statusText || 'Ошибка запроса') as ApiError;
    error.status = res.status;
    error.data = json;
    throw error;
  }

  return json;
}
